<div class="tableToolbar">
    <div class="tableToolbarLeft">
        @if (customButtonsLeft(); as template) {
        	<ng-container [ngTemplateOutlet]="template"></ng-container>
        }
    </div>

    <div class="tableToolbarRight">
        @if (customButtonsRightBefore(); as template) {
        	<ng-container [ngTemplateOutlet]="template"></ng-container>
        }

        @if (showTableFilter()) {
	        @if (toggleTableFilter()) {
		        <button class="transparent hideOnMobile" hisImage="FILTER_RESET" (click)="toggleTableFilter.set(false)">
		            <span>{{ 'de.his.faces.tags.table.tableFilter.disable' | hisUi }}</span>
		        </button>
				@if (showResetFilter()) {
					<button class="transparent hideOnMobile" hisImage="PANEL_CLOSE" (click)="resetFilter.emit()">
						<span>{{ 'genericSearch.resultTable.tableFilter.resetFilter' | hisUi }}</span>
					</button>
				}
	        } @else {
		        <button class="transparent hideOnMobile" hisImage="filter" (click)="toggleTableFilter.set(true)">
	            	<span>{{ 'de.his.faces.tags.table.tableFilter.enable' | hisUi }}</span>
	        	</button>
	        }
        }

        @if (showExpandCollapse()) {
	        <button class="transparent" hisImage="TREE_INCREASE" (click)="expandAll.emit()">
	            <span>{{ 'view.components.tree.expand_all' | hisUi }}</span>
	        </button>
	        <button class="transparent" hisImage="TREE_DECREASE" (click)="collapseAll.emit()">
	            <span>{{ 'view.components.tree.collapse_all' | hisUi }}</span>
	        </button>
        }

		@if (customTableConfig(); as template) {
			<ng-container [ngTemplateOutlet]="template"></ng-container>
		} @else if (showTableConfig() !== false) {
			<his-table-config 
				[enableFrozenColumns]="enableFrozenColumns()"
				[enablePaginatorConfig]="enablePaginator()"
				[enableReorderableColumns]="enableReorderableColumns()"
				[hisTableId]="tableId()"
				[columns]="columns()"
				(saved)="tableConfigSaved.emit($event)">
			</his-table-config>
        }

        @if (customButtonsRightAfter(); as template) {
        	<ng-container [ngTemplateOutlet]="template"></ng-container>
        }
    </div>

	<div class="clearer"></div>
</div>